import { EmptyStateIcon } from "./empty-state-icon"
import { EmptyStateImage } from "./empty-state-image"

export { EmptyStateImageSize } from "./empty-state-image"
export const EmptyState = {
  Icon: EmptyStateIcon,
  Image: EmptyStateImage,
} as const
